// Queued webhook logs keep only a location marker in database metadata; the
// complete trigger response lives in the already-loaded S3 log output.
const resolveLogTriggerStep = ({ triggerStep, output }) => {
  if (!triggerStep?.responseLocation) {
    return triggerStep;
  }

  // Output is absent while the run is pending or when its upload never
  // happened (crash before the initial upload). Keep the trigger's timeline
  // slot without fabricating a successful empty response.
  const storedTrigger = output?.meta?.triggerStep;
  const response = storedTrigger?.stepId === triggerStep.stepId ? storedTrigger.response : undefined;

  return { ...triggerStep, response };
};

export default resolveLogTriggerStep;
